import React from "react";
import { connect } from "react-redux";
import { DashboardHeader } from "../../../../components/Header";
import { withRouter } from "../../../../utils/withRouter";
import { ShiftTransactions } from "../../../../components/Shifts";

class AggregatorCollectionsScreen extends React.Component {
  render() {
    const { searchParams } = this.props;

    const shiftId = searchParams.get("shiftId");
    return (
      <div className="card">
        <div className="card-body">
          <DashboardHeader
            title={shiftId ? `Shift Transactions  - ID: ${shiftId}` : "Shift Transactions"}
            titleClassName="text-primary"
          />
          <ShiftTransactions
            showAdd
            shiftId={shiftId}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(
  withRouter(AggregatorCollectionsScreen)
);
